import { cn } from '@/new/lib/utils';

export function NewChip({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'absolute -top-2.25 -right-4 z-10 rounded-full border border-teal-300 bg-teal-50 px-1.25 pt-0.25 text-[9px] font-bold text-teal-500',
        className,
      )}
    >
      NEW
    </span>
  );
}
